<script setup lang="ts">
import type { InterfaceUser } from "~/classes/users/InterfaceUser"

const props = defineProps({
  user: null,
  size: null
})

const { sidebarAvatarBubbleTestId } = useTestId()
const c = computed(() => generateColors(props.user?.email() || ""))
const id = useId()

const unknown = computed(() => {
  return !props.user?.email()
})
</script>

<template>
  <div
    :style="{ width: px(size), height: px(size) }"
    :data-testid="sidebarAvatarBubbleTestId"
    class="avatar-bubble"
    :class="{ unknown }"
  >
    <svg
      v-if="user?.email()"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        :cx="size / 2"
        :cy="size / 2"
        :r="size / 2"
        :fill="`url(#${id})`"
      />
      <defs>
        <linearGradient
          :id="id"
          x1="0"
          y1="0"
          :x2="size"
          :y2="size"
          gradientUnits="userSpaceOnUse"
        >
          <stop :stop-color="c[0]" />
          <stop offset="1" :stop-color="c[1]" />
        </linearGradient>
      </defs>
    </svg>
    <div v-else class="unknown-inner">
      ?
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.avatar-bubble
  @apply rounded-full aspect-square overflow-hidden
  &.unknown
    @apply border border-[#{$pill-b-outline}]

.unknown-inner
  @apply flex w-full h-full items-center justify-center text-[#{$global-t-secondary}]
</style>
